import { JobModel } from 'api/dto/Job.dto';
import { JobExtendedModel } from 'api/dto/JobExtended.dto';
import { Resource } from 'model/Resource';
import { TakeLatestNew } from 'shared/utils/type';

export const STORE_NAME = 'job';

export namespace JobState {
  export type Domain = {
    projectJobs: TakeLatestNew<Resource<JobModel[] | null>>;
    emailDistributionJobs: TakeLatestNew<Resource<JobExtendedModel[] | null>>;
    kioskDistributionJobs: TakeLatestNew<Resource<JobExtendedModel[] | null>>;
  };

  export const INITIAL_DOMAIN: Domain = {
    projectJobs: {
      data: Resource.createPendingResource<JobModel[]>(),
      requestId: '',
    },
    emailDistributionJobs: {
      data: Resource.createPendingResource<JobExtendedModel[]>(),
      requestId: '',
    },
    kioskDistributionJobs: {
      data: Resource.createPendingResource<JobExtendedModel[]>(),
      requestId: '',
    },
  };
}
